import { AfterViewInit, Component, Input, OnInit } from '@angular/core';
import { DefaultEditor } from 'angular2-smart-table';
import { OfbizListService } from '../ofbiz-list/ofbiz-list.service';

@Component({
  selector: 'ubs-ofbiz-cell-dropdown-editor',
  template: `<nb-select placeholder="Select Showcase" [selected]="selected" (selectedChange)=onSelectedChange($event)>
  <nb-option *ngFor="let opt of options" [value]="opt.key">{{opt?.description}}</nb-option>
</nb-select>`,
  styleUrls: ['./ofbiz-cell-dropdown-editor.component.scss']
})
export class OfbizCellDropdownEditorComponent extends DefaultEditor implements AfterViewInit {
  selected:string;
  options:any[];

  constructor(private ofbizListService:OfbizListService) { 
    super()
  }

  ngAfterViewInit(){
    let value = this.cell.getValue();
    let fieldName = this.cell.getColumn().id;
    console.log({Incoming:{Value:value,fieldName:fieldName}});
    this.ofbizListService.getDropdownOptions()
    .subscribe((data:any[]) => {
      //console.log({OptionData:data});
      let optionData = data.find(element => element.name == fieldName);
      if(optionData != null){
        this.options = optionData.options;
        
        let selectedOption = this.options.find(option => option["description"] == value);
        if(selectedOption != undefined){
          this.selected = selectedOption["key"];
        }
      }
    })
  }

  onSelectedChange(e){
    console.log(e);
    this.cell.setValue = e;
    /* let option = this.options.find(option => option.description == e);
    if(option){
      console.log({SelectedChange:e,value:option.key});
      this.cell.setValue(option.key);
    } */
  }

}
